import { useEffect, useRef } from 'react'
import { useAuth } from '../shared/contexts/AuthContext'
import { securityService } from '../lib/services/securityService'

export const useSessionActivity = () => {
  const { session } = useAuth()
  const activityIntervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (session?.access_token) {
      // Update session activity every 5 minutes
      const updateActivity = async () => {
        try {
          await securityService.updateSessionActivity(session.access_token)
        } catch (error) {
          console.error('Failed to update session activity:', error)
        }
      }

      // Update immediately
      updateActivity()

      // Set up interval for periodic updates
      activityIntervalRef.current = setInterval(updateActivity, 5 * 60 * 1000) // 5 minutes

      return () => {
        if (activityIntervalRef.current) {
          clearInterval(activityIntervalRef.current)
        }
      }
    }
  }, [session?.access_token])

  // Clean up on unmount
  useEffect(() => {
    return () => {
      if (activityIntervalRef.current) {
        clearInterval(activityIntervalRef.current)
      }
    }
  }, [])
} 